import React from 'react';

const SvgGi = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GI_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GI_svg__b" fill="#fff">
        <use xlinkHref="#GI_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#E34F4F"
        mask="url(#GI_svg__b)"
        d="M0 13.333h28V20H0zM9.333 8h8v5.333h-8z"
      />
      <path
        fill="#181A1A"
        mask="url(#GI_svg__b)"
        d="M10.667 12H12v1.333h-1.333zM14.667 12H16v1.333h-1.333zM9.333 6.667h1.333V8H9.333zM13.333 6.667h1.333V8h-1.333zM12 6.667h1.333V8H12zM16 6.667h1.333V8H16z"
      />
      <path
        fill="#E34F4F"
        mask="url(#GI_svg__b)"
        d="M9.333 5.333h1.333v1.333H9.333zM13.333 5.333h1.333v1.333h-1.333zM12 5.333h1.333v1.333H12zM16 5.333h1.333v1.333H16z"
      />
    </g>
  </svg>
);

export default SvgGi;
